module.exports = __webpack_public_path__ + "static/media/imgab2.3e406654.webp";